module.exports = __webpack_public_path__ + "static/media/united_card_4.bd15d811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/united_card_4.jpg
// module id = 525
// module chunks = 0